"use client";
import { useRouter } from "next/navigation";

export default function useRoutePush() {
    const router = useRouter();

    const routePush = (link?: string) => {
        if (link) {
            router.push(link);
        } else {
            window.location.reload();
        }
    };

    return routePush;
}
